import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Edit_FINANCECMZM_Conveyance1 = () => {
  const { id } = useParams();

  const [profile, setProfile] = useState(null);
  const [auditSummary, setAuditSummary] = useState(null);
  const [visitRows, setVisitRows] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [auditStatus, setAuditStatus] = useState("");
  const [auditRemarks, setAuditRemarks] = useState("");
  const [submitting, setSubmitting] = useState(false);
  // ✍️ Finance (editable)
  const [financeStatus, setFinanceStatus] = useState("");
  const [financeRemarks, setFinanceRemarks] = useState("");
  const navigate = useNavigate();


  /* ================= BRANCH COLOR GROUPING (UNCHANGED LOOK) ================= */
  const branchIndexMap = {};
  let branchCounter = 0;

  visitRows.forEach((row) => {
    if (!branchIndexMap[row.branch_name]) {
      branchIndexMap[row.branch_name] = branchCounter++;
    }
  });

  const getVisitBg = (branchName) => {
    const index = branchIndexMap[branchName] ?? 0;

    if (index % 2 === 0) {
      return {
        background: "rgb(212, 246, 255)",
        border: "1px solid rgb(180, 230, 245)",
      };
    }

    return {
      background: "rgb(124, 164, 240)",
      border: "1px solid rgb(170, 140, 225)",
      color: "#ffffff",
    };
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");

        // PROFILE
        const resProfile = await fetch(`${API_BASE_URL}profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const profileResult = await resProfile.json();
        if (!profileResult.status) {
          setMessage("Unable to load profile");
          return;
        }
        setProfile(profileResult.profile);

        // FINANCE SUMMARY
        const resAudit = await fetch(
          `${API_BASE_URL}getfinancecmzmdetails/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const auditResult = await resAudit.json();

        if (auditResult.status && Array.isArray(auditResult.data)) {
          const row = auditResult.data[0];
          setAuditSummary(row);

          setAuditStatus(row.audit_status || "");
          setAuditRemarks(row.audit_remarks || "");

          setFinanceStatus(row.finance_status || "");
          setFinanceRemarks(row.finance_remarks || "");
        }

        // VISITS
        const resVisits = await fetch(
          `${API_BASE_URL}getmyvisitdetails1/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const visitResult = await resVisits.json();
        setVisitRows(visitResult.status ? visitResult.data : []);
      } catch (err) {
        console.error(err);
        setMessage("Server error while loading data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleFinanceSubmit = async () => {
    if (!financeStatus) {
      alert("Please select Finance Status");
      return;
    }

    if (financeStatus === "Rejected" && !financeRemarks.trim()) {
      alert("Finance Remarks are mandatory when Rejected");
      return;
    }

    try {
      setSubmitting(true);
      const token = localStorage.getItem("authToken");

      const res = await fetch(
        `${API_BASE_URL}update_financecmzm_status/${id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            finance_status: financeStatus,
            finance_remarks: financeRemarks,
          }),
        }
      );

      const result = await res.json();
      if (result.status) {
        alert("✅ Finance action submitted successfully");
      } else {
        alert(result.message || "❌ Failed to submit");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error");
    } finally {
      setSubmitting(false);
    }
  };


  if (loading) {
    return <h3 style={{ padding: 20, color: "#6ca0dc" }}>Loading...</h3>;
  }

  return (
    <div
      className="hold-transition sidebar-mini layout-fixed"
      style={{ background: "#f4f7fb", fontSize: "12px" }}
    >
      <div className="wrapper">
        <Header />
        <Sidebar />

        <div className="content-wrapper" style={{ padding: "25px" }}>
          <h2
            style={{
              color: "#6ca0dc",
              fontWeight: 800,
              fontSize: "24px",
              marginBottom: "12px",
            }}
          >
            Conveyance Finance Details
          </h2>

          {message && (
            <div
              style={{
                padding: "12px",
                background: "#fdeeee",
                borderLeft: "4px solid #d87a7a",
                borderRadius: "8px",
                marginBottom: "18px",
                color: "#8b3f3f",
              }}
            >
              {message}
            </div>
          )}

          {/* PROFILE CARD */}
          {profile && (
            <div
              style={{
                background: "#ffffffee",
                padding: "15px 20px",
                borderRadius: "12px",
                border: "1px solid #e2e8f5",
                marginBottom: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              <b style={{ color: "#557a95" }}>Employee:</b>{" "}
              {profile.comp_name} ({profile.emp_code})
            </div>
          )}

          {/* AUDIT SUMMARY (UNCHANGED LOOK) */}
          {auditSummary && (
            <div
              style={{
                background: "#ffffff",
                padding: "16px 20px",
                borderRadius: "12px",
                border: "1px solid #d9e3f1",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "22px",
                  fontSize: "14px",
                  color: "#425b70",
                }}
              >
                <span><b>ID:</b> {auditSummary.id}</span>
                <span><b>Emp Code:</b> {auditSummary.emp_code}</span>
                <span><b>Name:</b> {auditSummary.comp_name}</span>
                <span><b>Role:</b> {auditSummary.role}</span>
                <span><b>Month:</b> {auditSummary.month_year}</span>
                 <span><b>Total Visit Count:</b> {auditSummary.role === 'cluster_manager' ?  auditSummary.total_visits_30 * 2 : auditSummary.total_visits_30}</span>
                <span><b>Total Amount:</b> ₹{auditSummary.total_visit_amount}</span>
                <span><b>Status:</b> {auditSummary.audit_status}</span>
                <span><b>Updated:</b> {auditSummary.updated_on}</span>
              </div>
            </div>
          )}

          {/* VISIT RECORDS (SAME LOOK) */}
          <h3 style={{ color: "#557a95", fontSize: "15px", marginBottom: "8px" }}>
            Visit Records ({visitRows.length} Visits)
          </h3>

          <div
            style={{
              maxHeight: "440px",
              overflowY: "auto",
              background: "#ffffffee",
              borderRadius: "10px",
              border: "1px solid #d9e3f1",
              padding: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            {visitRows.map((row, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "12px",
                  padding: "8px 10px",
                  marginBottom: "8px",
                  borderRadius: "8px",
                  fontSize: "12.5px",
                  ...getVisitBg(row.branch_name),
                }}
              >
                <span style={{ width: "60px" }}>
                  <b>V:</b> {index + 1}
                </span>

                <span style={{ width: "180px", whiteSpace: "nowrap" }}>
                  <b>
                    {row.branch === "OTHERS" ? "Others:" : "Branch:"}
                  </b>{" "}
                  {row.branch === "OTHERS"
                    ? row.branch_name
                    : row.branch_name}
                </span>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <b style={{ marginRight: "4px" }}>Date:</b>
                  <input
                    type="date"
                    value={row.visit_date}
                    disabled
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      height: "26px",
                      borderRadius: "4px",
                      border: "1px solid #9ad1d4",
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <b>From:</b>
                  <input
                    type="time"
                    value={row.visit_from_time}
                    disabled
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      height: "26px",
                      borderRadius: "4px",
                      border: "1px solid #9ad1d4",
                    }}
                  />
                  <b>to</b>
                  <input
                    type="time"
                    value={row.visit_to_time}
                    disabled
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      height: "26px",
                      borderRadius: "4px",
                      border: "1px solid #9ad1d4",
                    }}
                  />
                </div>

                <span style={{ width: "65px" }}>
                  <b>Day:</b> {row.visit_day}
                </span>

                <input
                  type="text"
                  value={row.purpose}
                  disabled
                  style={{
                    width: "120px",
                    fontSize: "12px",
                    padding: "4px",
                    height: "26px",
                    borderRadius: "4px",
                    border: "1px solid #9ad1d4",
                  }}
                />

                <input
                  type="text"
                  value={row.remarks}
                  disabled
                  style={{
                    width: "120px",
                    fontSize: "12px",
                    padding: "4px",
                    height: "26px",
                    borderRadius: "4px",
                    border: "1px solid #9ad1d4",
                  }}
                />

                <span
                  style={{
                    background: "#6ca0dc",
                    color: "#fff",
                    padding: "3px 10px",
                    borderRadius: "14px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  ₹{Number(row.amount).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
          <div
            style={{
              background: "#ffffff",
              padding: "16px",
              borderRadius: "12px",
              border: "1px solid #d9e3f1",
              marginBottom: "20px",
            }}
          >
            <h4 style={{ color: "#557a95", marginBottom: "10px" }}>Audit Action</h4>

            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <select
                value={auditStatus}
                onChange={(e) => setAuditStatus(e.target.value)}
                style={{ height: "30px", padding: "5px", borderRadius: "6px" }}
                disabled
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>

              <textarea
                placeholder="Audit Remarks"
                value={auditRemarks}
                onChange={(e) => setAuditRemarks(e.target.value)}
                rows={2}
                style={{ width: "300px", padding: "6px", borderRadius: "6px" }}
                disabled
              />


            </div>
            <h4 style={{ color: "#557a95", marginBottom: "10px" }}>Finance Action</h4>
            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <select
                value={financeStatus}
                onChange={(e) => setFinanceStatus(e.target.value)}
                style={{ height: "30px", padding: "5px", borderRadius: "6px" }}

              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>

              <textarea
                placeholder="Finance Remarks"
                value={financeRemarks}
                onChange={(e) => setFinanceRemarks(e.target.value)}
                rows={2}
                style={{ width: "300px", padding: "6px", borderRadius: "6px" }}

              />

              <button
                onClick={handleFinanceSubmit}
                disabled={submitting}
                style={{
                  background: "#28a745",
                  color: "#fff",
                  padding: "6px 18px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {submitting ? "Submitting..." : "Submit Finance"}
              </button>
              <button
                onClick={() => navigate("/finance_cmzmconveyance")}
                style={{
                  background: "#6c757d",
                  color: "#fff",
                  padding: "12px 36px",
                  fontSize: "15px",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "700",
                  boxShadow: "0 4px 12px rgba(108,117,125,0.4)",
                }}
              >
                ❌ Cancel
              </button>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Edit_FINANCECMZM_Conveyance1;
